var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5188 18.12C18.1381 16.233 20.0656 13.2975 20.0498 10.026C20.0498 5.73825 16.5623 2.25 12.2753 2.25C7.98834 2.25 4.50009 5.73525 4.50009 10.02C4.48509 13.2952 6.41184 16.2322 8.03109 18.1192C9.87384 20.2672 11.7466 21.6 11.8253 21.6555C12.0901 21.8445 12.4613 21.8445 12.7253 21.6555C12.8041 21.5992 14.6836 20.259 16.5188 18.12ZM12.4171 19.935L12.2753 20.0505L12.1336 19.935C11.3371 19.2885 9.80484 17.9445 8.48409 16.2037C6.85959 14.0632 6.04134 11.9842 6.05034 10.0245C6.05034 6.5925 8.84259 3.80025 12.2753 3.80025C15.7066 3.80025 18.4996 6.59475 18.5011 10.0297C18.5101 11.988 17.6911 14.0655 16.0666 16.2052C14.7458 17.9467 13.2136 19.2892 12.4171 19.935Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34575 9.50025L8.25 10.596L11.6392 13.9853L17.028 8.59575L15.9322 7.5L11.6392 11.793L9.34575 9.50025Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.0ec9b1dcdbc31f3e0dad2446e2c08806.svg";
export { ForwardRef as ReactComponent };